module.exports = __webpack_public_path__ + "4ae2ff57e6f0f77d675864dc5291cbdd.svg";